<template>
  <div class="teamWarp" v-if="isMobile != 0">
    <div class="pc" v-if="isMobile == 1">
<!--      <header-view ref="headers"></header-view>-->
      <div class="hNoFex">
        <header-view :fex="false" ref="headers"></header-view>
      </div>
      <div class="warpAA">
        <div class="page-5" :style="'padding-bottom:'+footerHeight+'px;padding-top:'+headerHeight+'px'">
          <div class="page5Warp">
            <div class="title fAb flexSw">
              <div>Viewpoint</div>
              <PcBak :home-index="5"></PcBak>
            </div>
          </div>
        </div>
        <div class="detailContent">
          <div class="title fOH">
            {{info.title}}
          </div>
          <div class="time fOH">{{ info.time }}</div>
          <div class="content fOR" v-html="info.desc">
          </div>
          <div v-if="info.more_url" @click="openMore" class="moreBtn fOb">Read More</div>
        </div>
      </div>
    </div>
    <div class="mobile pw100" v-else>
<!--      <MobileHeader></MobileHeader>-->
      <div class="noFex">
        <MobileHeader :fex="false"></MobileHeader>
      </div>
      <div class="detailWarp h100 w100">
        <div class="detailWarpTop w100">
          <div class="zwHeader w100"></div>
          <div class="title fAb">
            <div>Viewpoint</div>
            <div class="mobileBak">
              <mobileBak :home-index="5"></mobileBak>
            </div>
          </div>
        </div>
        <div class="detailContent w100">
          <div class="title fOH">
            {{info.title}}
          </div>
          <div class="time fOH">{{ info.time }}</div>
          <div class="content fOR" v-html="info.desc">
          </div>
          <div v-if="info.more_url" @click="openMore"  class="moreBtn fOb">Read More</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import headerView from "@/components/Common/Header.vue";
import MobileHeader from "@/components/Common/MobileHeader.vue";
import PcBak from "@/components/Common/pcBak.vue";
import mobileBak from "@/components/Common/mobileBak.vue";

export default {
  components: {mobileBak, PcBak, headerView, MobileHeader},
  data() {
    return {
      headerHeight: 104,
      footerHeight: 0,
      tList: []
    }
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    info(){
      return this.$store.getters.viewPointInfo
    }
  },
  mounted() {
    if(Object.keys(this.info).length === 0){
      this.getDetail(this.$route.query.id)
    }
  },
  created() {
    this.$store.dispatch('setPageCurrentIndex', 5)
  },
  methods:{
    async getDetail(id){
      let {data} = await this.$api.getData('view-point/detail/' + id,{})
      await this.$store.dispatch('setStoreByKeyData', {key: 'setViewPointInfo', data: data})
    },
    openMore(){
      if(this.info.more_url){
        try {
          window.open(this.info.more_url)
        }catch (e){
          window.location.href = this.info.more_url
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.mobile {
  position: relative;
  .noFex{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
  }
  .mobileBak{
    position: absolute;
    right: 1.3rem;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
  }
  .detailWarp {
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;
    width: 100%;
    .detailContent {
      flex: 1;
      overflow: hidden;
      overflow-y: auto;
      padding: 1rem;
      box-sizing: border-box;

      .title {
        color: rgba(34, 34, 34, 1);
        font-size: 1.2rem;
      }

      .time {
        font-size: .75rem;
        color: rgba(143, 202, 221, 1);
        padding: .7rem 0;
      }

      .content {
        color: rgba(65, 65, 65, 1);
        font-size: .9rem;
        line-height: 1.5rem;
      }
      .moreBtn{
        margin-top: 1rem;
        color: #3C82B7;
        font-size: .9rem;
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .detailWarpTop {
      background-image: url("../../assets/image/mobile_viewpoint_detail_bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;

      .title {
        color: #fff;
        font-size: 1.5rem;
        padding: 1rem;
        position: relative;
        width: 100%;
        text-align: center;
        box-sizing: border-box;
      }
    }
  }
}
.pc {
  scrollbar-width: none; /* Chrome, Safari, Opera */
  -ms-overflow-style: none; /* IE and Edge */
}

.pc::-webkit-scrollbar {
  display: none; /* Firefox */
}
.pc {
  height: 100vh;
  position: relative;
  overflow: hidden;
  overflow-y: auto;
  .hNoFex{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
  }
  .warpAA {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;
  }

  .detailContent {
    //flex: 1;
    //overflow: auto;
    -ms-overflow-style: none; /* IE 和 Edge */
    scrollbar-width: none; /* Firefox */
    width: 70%;
    margin: auto;
    padding-bottom: 1rem;

    .moreBtn{
      margin-top: 1rem;
      color: #3C82B7;
      font-size: 1rem;
      cursor: pointer;
      text-decoration: underline;
    }
    .title {
      color: #222;
      font-size: 1.2rem;
      margin-top: 2rem;
    }

    .content {
      margin-top: 2rem;
      color: #414141;
      font-size: 1rem;
      line-height: 1.8rem;
    }

    .time {
      color: #8FCADD;
      font-size: .95rem;
      margin-top: .9rem;
    }
  }

  .page-5 {
    width: 100%;
    background-image: url("../../assets/image/viewpoint_detail_bg.png");

    .page5Warp {
      width: 70%;
      box-sizing: border-box;
      padding: 1rem 0 1rem;
      margin: auto;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      overflow: hidden;

      .title {
        text-align: left;
        padding-bottom: 1rem;
        color: #fff;
        font-size: 2.2rem;
        width: 100%;
      }
    }
  }
}
</style>
